import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "Agile and Scrum Fundamentals",
  "Roles and Responsibilities in Scrum",
  "Sprint Planning and Execution",
  "Scrum Artifacts and Events",
  "Scaling Scrum for Larger Projects",
  "Practical Case Studies",
  "Certification Preparation and Mock Tests",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 2 Months", desc: "Intensive Scrum and Agile training." },
  { title: "Mock Exam",                      desc: "Score minimum 75% to proceed." },
  { title: "Live Projects & Case Studies",   desc: "Apply Scrum in real-world scenarios." },
  { title: "Monthly Assessment & Report",    desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Industry-recognised certification on completion." },
];
const ScrumMaster = () => (
  <CourseDetailTemplate title="Scrum Master Certification Course"
    description="Become a certified Scrum Master and lead Agile projects effectively! Learn the Scrum framework, Agile principles, and team management skills. Enhance your career with hands-on training and real-world scenarios."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["Scrum", "Agile", "Sprint Planning", "Jira", "Kanban"]}
    programName="Scrum Master Certification Course"
  />
);
export default ScrumMaster;
